"use client";

import { useState } from "react";
import BlogCard from "../../../blog/BlogCard";

export default function FeaturedBlogsClient(props: {
  initialData: any[];
}) {
  const { initialData } = props;
  const [featuredBlogs, setFeaturedBlogs] = useState<any[]>(initialData);

  // const fetchData = async (index = 0) => {
  //   setIsLoading(true);
  //   const res = await apiFetch({
  //     route: `blog/featured?index=${index}`,
  //   });
  //   if (res.length < DEFAULT_DATA_LIMIT) {
  //     setHasMore(false);
  //   }
  //   setIsLoading(false);

  //   return res;
  // };

  // const next = (page: number) => {
  //   fetchData(page).then((data) => {
  //     setFeaturedBlogs([...featuredBlogs, ...data]);
  //   });
  // };

  // useEffect(() => {
  //   fetchData(0).then((data) => {
  //     setFeaturedBlogs(data);
  //   });
  // }, []);

  if (!Array.isArray(featuredBlogs) || !featuredBlogs.length) return <></>;

  return (
    <>
      {/* <InfiniteScroll
        hasMore={hasMore}
        next={next}
        loading={
          <div className="container" id="blog-client-card-skeleton">
            {Array.from(Array(6).keys()).map((key: number) => (
              <BlogSkeleton key={key} />
            ))}
          </div>
        }
        isLoading={isLoading}
        skeletonElementId="blog-client-card-skeleton"
        dataLength={featuredBlogs?.length || 0}
      > */}
      {featuredBlogs.map((blog: any, index: number) => {
        return <BlogCard titleHeadingLevel="h3" {...blog} key={index} />;
      })}
      {/* </InfiniteScroll> */}
    </>
  );
}
